export const CurrencyValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_CurrencyName.trim()) {
      errors.vc_CurrencyName = 'Currency Name is required';
    } 
    if (!formData.vc_CurrencyCode.trim()) {
        errors.vc_CurrencyCode = 'Currency Code is required';
    }
    if (!formData.vc_CurrencySymbol.trim()) {
        errors.vc_CurrencySymbol = 'Currency Symbol is required';
    }
    if (!formData.dec_CurrencyToBaseRate.trim()) {
        errors.dec_CurrencyToBaseRate = 'Base Currency is required';
    }  
    if (!formData.dec_BaseToCurrencyRate.trim()) {
        errors.dec_BaseToCurrencyRate = 'Exchange Rate is required';
    } 
    if (!formData.dec_BaseToCurrencyRate.trim()) {
        errors.dec_BaseToCurrencyRate = 'Exchange Rate is required';
    } 
    if (!formData.vc_MajorCurrency.trim()) {
        errors.vc_MajorCurrency = 'Major Currency Unit is required';
    } 
    if (!formData.vc_MinorCurrency.trim()) {
        errors.vc_MinorCurrency = 'Minor Currency Unit is required';
    } 
    return errors;
  };
  
 